import { RemoteGetAllCountries } from 'data/usecases/locations';
import { GetAllCountriesUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCountries } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCountries = (): GetAllCountriesUseCaseInterface =>
  new RemoteGetAllCountries(makeApiUrlCountries(), makeAxiosHttpClient());
